
<template>
  <v-container
    class="pa-0 elevation-1"
  >
    <v-toolbar
      flat
      color="white"
    >
      <v-btn
        icon
        to="/tasklist/index"
      >
        <v-icon>{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('TaskList.AttentionManagement.Title') }}</v-toolbar-title>
    </v-toolbar>
    <v-tabs
      v-if="myAttentionStaffs.length !== 0"
      @change="tabChange"
    >
      <v-tab>
        {{ $t('TaskList.AttentionManagement.attentionMe') }}
      </v-tab>
      <v-tab
        v-for="(staff) in myAttentionStaffs"
        :key="staff.euid"
      >
        {{ $chPtObjData('chinStaffName', staff) }}
      </v-tab>
    </v-tabs>
    <s-attention-task-manage-table :euid="euid" />
  </v-container>
</template>

<script>
import SAttentionTaskManageTable from './components/SAttentionTaskManageTable'
import { mapState } from 'vuex'
import { workflowModule, staffModule } from '../../store/moduleName'
import { mdiArrowLeft } from '@mdi/js'

export default {
  components: {
    SAttentionTaskManageTable
  },
  data: () => ({
    mdiArrowLeft: mdiArrowLeft,
    euid: ''
  }),
  computed: {
    ...mapState({
      workItem: state => state[workflowModule].item,
      myAttentionStaffs: state => state[workflowModule].myAttentionStaffs,
      myInfo: state => state[staffModule].info,
      items: state => state[workflowModule].items
    })
  },
  async created () {
    if (!this.myInfo) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
    if (!this.myAttentionStaffs.length || this.myAttentionStaffs.length < 0) {
      this.$store.dispatch(workflowModule + '/getMyAttentionStaffs', this.items[0].businessCode)
    }
    this.euid = this.myInfo.euid
  },
  methods: {
    tabChange: function (number) {
      if (number === 0) {
        this.euid = this.myInfo.euid // yourself
      } else {
        this.euid = this.myAttentionStaffs[number - 1].euid
      }
      this.$store.dispatch(workflowModule + '/getStaffsAttentionMe', this.euid)
    }
  }
}
</script>
